module.exports = __webpack_public_path__ + "media/images/emblems/Arnex-sur-Nyon-coat_of_arms-0a8dcfca70e8691fcfecc2625977d258.svg";